import { Flex } from '@enechain/ecloud-designsystem'

import { HelpIcon } from '~/components/common/HelpIcon'

/**
 * 計画一覧の列見出し + 補足 (?) ツールチップ。並べ替えできない見出し用
 * (クリックハンドラを持たないので ? で並べ替えは走らない)。
 */
export const PlanListColumnHeader = ({
  label,
  help,
}: {
  label: string
  help: string
}): React.ReactElement => (
  <Flex as="span" alignItems="center" justifyContent="center" gap="4px">
    {label}
    <HelpIcon ariaLabel={label} content={help} />
  </Flex>
)
